import { detectTimezone, getTimezoneFromQuery } from '@calendly/timezone-tools'

const initialState = {
  selected: null,
  detected: detectTimezone(),
  fromQuery: getTimezoneFromQuery()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_TIMEZONE':
      return {
        ...state,
        selected: action.timezone
      }
    default:
      return state
  }
}
